import { useState } from 'react';
import { GridFilterModel } from '@mui/x-data-grid-premium';
import { useFetchAllGlobalSitelinksQuery } from '../../slices/sitelinkSlice';
import GlobalSitelinkSection from './GlobalSitelinkSection';

const AllGlobalDescriptionsSection: React.FC = () => {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 24,
  });
  const [queryOptions, setQueryOptions] = useState<{
    filterModel?: GridFilterModel;
  }>();
  const { data = { total: 0, results: [] }, isFetching } =
    useFetchAllGlobalSitelinksQuery({
      ...paginationModel,
      ...queryOptions,
    });

  return (
    <GlobalSitelinkSection
      data={data}
      isFetching={isFetching}
      setQueryOptions={setQueryOptions}
      paginationModel={paginationModel}
      setPaginationModel={setPaginationModel}
    />
  );
};
export default AllGlobalDescriptionsSection;
